import { RichText } from '@wmfe/mach-pro-components-react';

export { RichText };

export default RichText;
